import React from 'react';
import { BrowserRouter as Router, Link, Route, Switch } from 'react-router-dom';
import Home from './Pages/Home';
import About from './Pages/About';
// import Shop from './Pages/Shop';
import Contact from './Pages/Contact';
// import Detail from './Pages/Detail';
import Card from './Pages/Card';
import Checkout from './Pages/Checkout';
import Categories from './Pages/Categories';
// import Thankyou from './Pages/Thankyou';
import Header from './Components/Header';
import Footer from './Components/Footer';

// import demo from './Pages/demo';
// import CategoriesShop from './Pages/CategoriesShop';
import SearchData from './Pages/SearchData';

// import Signup from './Pages/Admin/Signup';
// import EditCard from "./Pages/EditCart"
// import CategoriesBook from './Pages/CategoriesBook';
// import CategoriesBags from './Pages/CategoriesBags';
// import CategoriesShoes from './Pages/CategoriesShoes';
// import ShoesProduct from './Pages/ShoesProduct';
// import ShoesProductDetails from './Pages/ShoesProductDetails';
// import SchoolClassProduct from './Pages/SchoolClassProduct';
// import BagsClassProduct from './Pages/BagsClassProduct';
// import chat from './Pages/chat';
// import SignupOtp from './Pages/SignupOtp';


// import whatapps from './assets/images/what.png';






// import SubCategories from './Pages/Categories';
// import SubCategoriesProduct from './Pages/SubCategoriesProduct';















import Privacy from './Pages/Privacy';
import consign from './Pages/consign';
// import Shipping from './Pages/Shipping';
import tracking from './Pages/tracking';
import FAQ from './Pages/FAQ';
import Shop from './Pages/Shop';
// import SaleSubCategoriesProduct from './Pages/SaleSubCategoriesProduct';
// import menSubCategoriesProduct from './Pages/menSubCategoriesProduct';
// import womenSubCategoriesProduct from './Pages/womenSubCategoriesProduct';
import Cancellation from './Pages/cancellation';
import Refund from './Pages/refund';
import Return from './Pages/return';

import SubCategoriesProduct from './Pages/SubCategoriesProduct';
import SubCategoriesProductDetails from './Pages/SubCategoriesProductDetails';
import SubCategoriesProductDetails1 from './Pages/SubCategoriesProductDetails1';
import SubCategoriesProductDetails2 from './Pages/SubCategoriesProductDetails2';
import SizeProductDetail from './Pages/SizeProductDetail';
import thankyou from './Pages/Thankyou';
import chat from './Pages/chat';
// import WomenOnlySubCategoriesProduct from './Pages/WomenOnlySubCategoriesProduct';
// import MenOnlySubCategoriesProduct from './Pages/MenOnlySubCategoriesProduct';
import SubCategoriesProduct1 from './Pages/SubCategoriesProduct1';
import SubCategoriesProduct2 from './Pages/SubCategoriesProduct2';
import Favorite from './Pages/Favorite';
import whislist from './Pages/whislist';
// import GardenAccessories from './Pages/GardenAccessories';
// import CategoriesUniform from './Pages/CategoriesUniform';
// import UniformClassProduct from './Pages/UniformClassProduct';
// import UniformProductDetails from './Pages/UniformProductDetails';
// import SchoolBookProductDetail from './Pages/SchoolBookProductDetail';
// import BagsProductDetail from './Pages/BagsProductDetail';
// import ArrivalCategoriesProduct from './Pages/ArrivalCategoriesProduct';

import whatapps from './assets/images/what.png';

// import teacherform from './Pages/teacherform';
// import studentform from './Pages/studentform';
import Shipping from './Pages/Shipping';
import Term from './Pages/Term';
import ab from './Pages/ab';
import expertpick from './Pages/expertpick';
import recommendedproduct from './Pages/recommendedproduct';
import newArrival from './Pages/newArrival';

import Error from './Pages/Error';
// import submain from './Pages/submain';


import Sitemap from './Pages/Sitemap';







import Link1 from './Pages/Link (1)';
import Link2 from './Pages/Link (2)';
import Link3 from './Pages/Link (3)';
import Link4 from './Pages/Link (4)';
import Link5 from './Pages/Link (5)';
import Link6 from './Pages/Link (6)';
import Link7 from './Pages/Link (7)';
import Link8 from './Pages/Link (8)';
import Link9 from './Pages/Link (9)';
import Link10 from './Pages/Link (10)';
import Link11 from './Pages/Link (11)';
import Link12 from './Pages/Link (12)';
import Link13 from './Pages/Link (13)';
import Link14 from './Pages/Link (14)';
import Link15 from './Pages/Link (15)';
import Link16 from './Pages/Link (16)';
import Link17 from './Pages/Link (17)';
import Link18 from './Pages/Link (18)';
import Link19 from './Pages/Link (19)';
import Link20 from './Pages/Link (20)';
import Link21 from './Pages/Link (21)';
import Link22 from './Pages/Link (22)';
import Link23 from './Pages/Link (23)';
import Link24 from './Pages/Link (24)';
import Link25 from './Pages/Link (25)';
import Link26 from './Pages/Link (26)';
import Link27 from './Pages/Link (27)';
import Link28 from './Pages/Link (28)';
import Link29 from './Pages/Link (29)';
import Link30 from './Pages/Link (30)';
// import Link31 from './Pages/Link (31)';
// import Link32 from './Pages/Link (32)';
// import Link33 from './Pages/Link (33)';
// import Link34 from './Pages/Link (34)';
// import Link35 from './Pages/Link (35)';
// import Link36 from './Pages/Link (36)';
// import Link37 from './Pages/Link (37)';
// import Link38 from './Pages/Link (38)';
// import Link39 from './Pages/Link (39)';
// import Link40 from './Pages/Link (40)';
// import Link41 from './Pages/Link (41)';
// import Link42 from './Pages/Link (42)';
// import Link43 from './Pages/Link (43)';
// import Link44 from './Pages/Link (44)';
// import Link45 from './Pages/Link (45)';
// import Link46 from './Pages/Link (46)';
// import Link47 from './Pages/Link (47)';
// import Link48 from './Pages/Link (48)';
// import Link49 from './Pages/Link (49)';
// import Link50 from './Pages/Link (50)';
// import Link51 from './Pages/Link (51)';
// import Link52 from './Pages/Link (52)';
// import Link53 from './Pages/Link (53)';
// import Link54 from './Pages/Link (54)';
// import Link55 from './Pages/Link (55)';
// import Link56 from './Pages/Link (56)';
// import Link57 from './Pages/Link (57)';
// import Link58 from './Pages/Link (58)';
// import Link59 from './Pages/Link (59)';
// import Link60 from './Pages/Link (60)';
// import Link61 from './Pages/Link (61)';
// import Link62 from './Pages/Link (62)';
// import Link63 from './Pages/Link (63)';
// import Link64 from './Pages/Link (64)';
// import Link65 from './Pages/Link (65)';
// import Link66 from './Pages/Link (66)';
// import Link67 from './Pages/Link (67)';
// import Link68 from './Pages/Link (68)';
// import Link69 from './Pages/Link (69)';
// import Link70 from './Pages/Link (70)';
// import Link71 from './Pages/Link (71)';
// import Link72 from './Pages/Link (72)';
// import Link73 from './Pages/Link (73)';
// import Link74 from './Pages/Link (74)';
// import Link75 from './Pages/Link (75)';
// import Link76 from './Pages/Link (76)';
// import Link77 from './Pages/Link (77)';
// import Link78 from './Pages/Link (78)';
// import Link79 from './Pages/Link (79)';
// import Link80 from './Pages/Link (80)';
// import Link81 from './Pages/Link (81)';
// import Link82 from './Pages/Link (82)';
// import Link83 from './Pages/Link (83)';
// import Link84 from './Pages/Link (84)';
// import Link85 from './Pages/Link (85)';
// import Link86 from './Pages/Link (86)';
// import Link87 from './Pages/Link (87)';
// import Link88 from './Pages/Link (88)';
// import Link89 from './Pages/Link (89)';
// import Link90 from './Pages/Link (90)';
// import Link91 from './Pages/Link (91)';
// import Link92 from './Pages/Link (92)';
// import Link93 from './Pages/Link (93)';
// import Link94 from './Pages/Link (94)';
// import Link95 from './Pages/Link (95)';
// import Link96 from './Pages/Link (96)';
// import Link97 from './Pages/Link (97)';
// import Link98 from './Pages/Link (98)';
// import Link99 from './Pages/Link (99)';







// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';
// import Error from './Pages/Error';



import whatapps1 from './assets/images/png.png';

import Pages from './Pages/Pages';


// import Privacy from './Pages/Privacy';
// import MainUserSignup from './Pages/MainUserSignup';
// import MainUserLogin from './Pages/MainUserLogin';
// import forgetpassaccount from './Pages/forgetpassaccount';


// import help from './Pages/help';
// import userDashboard from './Pages/userDashboard';
// import EditNameAddress from './Pages/EditNameAddress';
// import userDashOrderDetails from './Pages/userDashOrderDetails';


// import SchoolCategories from './Pages/SchoolCategories';
// import SchoolClassesCategories from './Pages/SchoolClassesCategories';
// import SchoolClassesCategoriesProduct from './Pages/SchoolClassesCategoriesProduct';
// import SchoolClassesCategoriesProductDetail from './Pages/SchoolClassesCategoriesProductDetail';


// import $ from 'jquery';


// import "https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.10.0/css/all.min.css";
import "./bootstrap.min.css"
import "./all.css"
import "./custom.css"
import "./bootsnav.css"
import "./responsive.css"
import "./style1.css"
import "./css/style.css";
import "./lib/owlcarousel/assets/owl.carousel.min.css";

import "./css1/custom.css";
import "./css1/responsive.css";
import "./css1/bootstrap-select.css";
import "./css1/baguetteBox.min.css";
import "./css1/owl.carousel.min.css";
import "./css1/bootsnav.css";
import "./css1/code_animate.css";
import "./css1/carousel-ticker.css";
import "./css1/superslides.css";
import "./css1/all.css";
import "./css1/style.css";

import "./css1/bootsnav";

import "./asset1/vendor/line-awesome/line-awesome/line-awesome/css/line-awesome.min.css";
import "./asset1/css/bootstrap.min.css";
// import "./asset1/css/plugins/owl-carousel/owl.carousel.css";
import "./asset1/css/plugins/jquery.countdown.css";
import "./asset1/css/plugins/magnific-popup/magnific-popup.css";
import "./asset1/css/style.css";
import "./asset1/css/skins/skin-demo-26.css";
import "./asset1/css/demos/demo-26.css";





function App() {
  
  return (
    <div className="App" >                    
     {/* <a href="https://wa.me/923008596274" target="_blank"><img src={whatapps} alt="" style={{position : "fixed" ,zIndex : "999999", top : "80%" , right : "10px",width:"70px",height : "70px"}}/></a> */}
     <a href="tel:+923008596274" target="_blank"><img src={whatapps1} alt="" style={{position : "fixed" ,zIndex : "999999", top : "80%" , right : "15px",width:"50px",height : "50px"}}/></a>
     <a href="https://wa.me/923008596274?text=Hi *Malook.Pk *! I need more info about Malook.Pk  https://Malook.net" target="_blank"><img src={whatapps} alt="" style={{position : "fixed" ,zIndex : "999999", top : "72%" , right : "10px",width:"60px",height : "60px"}}/></a>
     
     
      <Router>

        <Header />
        
        <Switch>
          <Route exact path='/' component={Home} />
          <Route exact path='/term-policy' component={Term} />
          <Route exact path='/Shipping' component={Shipping} />
          <Route exact path='/product/new-arrival' component={newArrival} />
          <Route exact path='/product/recommended-product' component={recommendedproduct} />
          <Route exact path='/product/expert-pick' component={expertpick} />

          <Route exact path='/shop-all' component={ab} />
          <Route exact path='/privacy' component={Privacy} />
          <Route exact path='/cancellation' component={Cancellation} />
          <Route exact path='/refund' component={Refund} />
          <Route exact path='/return' component={Return} />
          <Route exact path='/favorite' component={Favorite} />
          <Route exact path='/whislist' component={whislist} />
          <Route exact path='/thankyou' component={thankyou} />
          <Route exact path='/consign' component={consign} />
          <Route exact path='/checkout' component={Checkout} />
          <Route exact path='/FAQ' component={FAQ} />
          <Route exact path='/chat' component={chat} />
          <Route exact path='/cart' component={Card} />
          <Route exact path='/all-shop' component={Shop} />
          <Route exact path='/contact' component={Contact} />
          <Route exact path='/about' component={About} />
          <Route exact path='/track' component={tracking} />
          <Route exact path='/sitemap' component={Sitemap} />
          <Route exact path='/search/product-item' component={SearchData} />




          <Route exact path='/pages/:url' component={Pages} />








          {/* <Route exact path='/ab' component={SubCategoriesProduct} /> */}
          {/* <Route exact path='/categories/:categoriesName/all-products' component={SubCategoriesProduct} /> */}
          {/* <Route exact path='/categories-main/Annual Maintenance Contract' component={AMC} />
          <Route exact path='/categories-main/Landscaping' component={Land} /> */}
          {/* <Route exact path='/categories-main/Garden Accessories' component={GardenAccessories} /> */}
          <Route exact path='/main-categories/:categoriesName' component={Categories} />
          <Route exact path='/categories/:categoriesName/all-products' component={SubCategoriesProduct2} />
          <Route exact path='/categories/:categoriesName/:categoriesName1/all-products' component={SubCategoriesProduct1} />
          <Route exact path='/categories/:categoriesName/:categoriesName1/:categoriesName2/all-products' component={SubCategoriesProduct} />
          <Route exact path='/categories/:categoriesName/:categoriesName1/:categoriesName2/all-products/:productName/:productId' component={SubCategoriesProductDetails} />
          <Route exact path='/categories/:categoriesName/:categoriesName1/all-products/:productName/:productId' component={SubCategoriesProductDetails2} />
          <Route exact path='/categories/:categoriesName/all-products/:productName/:productId' component={SubCategoriesProductDetails1} />
          {/* <Route exact path='/main-categories/:categoriesName/all-products/:productName/:productId' component={submain} /> */}
          <Route exact path='/main-categories/:categoriesName/:categoriesName1/:categoriesName2/all-products/:productName/:productId' component={SizeProductDetail} />

          

           <Route exact path='/hire-the-best-fashion-designers-in-the-united-states' component={Link1} />
          <Route exact path='/luxury-fashion-designer-clothing-in-usa' component={Link2} />
          <Route exact path='/world-famous-luxury-brands-and-designers-in-usa' component={Link3} />
          <Route exact path='/custom-clothing-design-and-sell-online-in-usa' component={Link4} />
          <Route exact path='/designer-clothing-luxury-fashion-women-dresses' component={Link5} />
          <Route exact path='/women-clothes-designer-for-clothing-in-usa' component={Link6} />
          <Route exact path='/best-clothes-designer-for-clothing-in-usa' component={Link7} />
          <Route exact path='/clothes-designer-for-clothing-in-usa-online' component={Link8} />
          <Route exact path='/cheap-clothes-designer-for-clothing-in-usa' component={Link9} />
          <Route exact path='/women-dresses-usa-shop-original-clothes-online' component={Link10} />
          <Route exact path='/wedding-dresses-bridesmaids-prom-gowns-in-usa' component={Link11} />
          <Route exact path='/sale-usa-bridal-wedding-dresses-bridal-shops-near-me' component={Link12} />
          <Route exact path='/wedding-gowns-dresses-evening-dresses-in-usa' component={Link13} />
          <Route exact path='/bridal-collection-usa-shop-wedding-dresses-online' component={Link14} />
          <Route exact path='/women-bridal-dress-in-usa-online' component={Link15} />
          <Route exact path='/maxi-women-bridal-dress-in-usa' component={Link16} />
          <Route exact path='/luxury-wedding-dresses-designer-formal-wear-usa' component={Link17} />
          <Route exact path='/usa-bridal-wedding-dresses-bridal-shops-near' component={Link18} />
          <Route exact path='/wedding-dresses-bridal-dresses-malook-couture' component={Link19} />
          <Route exact path='/pakistani-wedding-dresses-for-women-in-usa' component={Link20} />
          <Route exact path='/buy-latest-pakistani-wedding-dresses-in-usa' component={Link21} />
          <Route exact path='/luxurious-pakistani-bridal-dresses-in-usa' component={Link22} />
          <Route exact path='/pakistani-wedding-dresses-bridal-gowns' component={Link23} />
          <Route exact path='/pakistani-bridal-dresses-for-barat-in-usa' component={Link24} />
          <Route exact path='/buy-pakistani-bridal-dresses-wedding-wear-online' component={Link25} />
          <Route exact path='/pakistani-bridal-dresses-latest-designs-online' component={Link26} />
          <Route exact path='/wedding-dresses-wedding-reception-dresses-for-bride' component={Link27} />
          <Route exact path='/bridal-online-shop-dresses-outfits-for-every-event' component={Link28} />
          <Route exact path='/best-places-to-buy-wedding-dresses-online-of-2025' component={Link29} />
          <Route exact path='/luxury-wedding-dresses-gowns-online-bridal-shop' component={Link30} />
          {/* <Route exact path='/wedding-dresses-2025-bridal-gowns' component={Link31} />
          <Route exact path='/wedding-dresses-wedding-gowns-and-bridal-wear' component={Link32} />
          <Route exact path='/the-wedding-shop-bridal-gowns-wedding-party-attire' component={Link33} />
          <Route exact path='/buy-indian-wedding-dresses-online-in-usa' component={Link34} />
          <Route exact path='/womens-designer-wedding-dresses-sale-up-to-70-off' component={Link35} />
          <Route exact path='/womens-formal-dresses-evening-gowns' component={Link36} />
          <Route exact path='/formal-dresses-evening-gowns-for-women' component={Link37} />
          <Route exact path='/formal-dresses-women-malook-united-states' component={Link38} />
          <Route exact path='/formal-dresses-for-women-shop-online-usa' component={Link39} />
          <Route exact path='/womens-formal-wear-pakistani-dresses-in-usa' component={Link40} />
          <Route exact path='/women-formal-dress-in-usa-online' component={Link41} />
          <Route exact path='/best-women-formal-dress-in-usa' component={Link42} />
          <Route exact path='/formal-dress-for-women-office-wear' component={Link43} />
          <Route exact path='/shop-womens-formal-dresses-outfits-online-us' component={Link44} />
          <Route exact path='/womens-formal-dresses-evening-gowns' component={Link45} />
          <Route exact path='/womens-dresses-party-occasion-evening-dresses' component={Link46} />
          <Route exact path='/buy-formal-dresses-for-women-at-best-prices' component={Link47} />
          <Route exact path='/formal-dress-sold-on-malook-united-states' component={Link48} />
          <Route exact path='/formal-dresses-sexy-womens-formal-gowns' component={Link49} />
          <Route exact path='/designer-formal-dresses-and-evening-gowns-for-women' component={Link50} />
          <Route exact path='/formal-dresses-evening-gowns-long-elegant' component={Link51} />
          <Route exact path='/womens-designer-formal-dresses-evening-gowns' component={Link52} />
          <Route exact path='/evening-dresses-womens-party-cocktail-formal-dresses' component={Link53} />
          <Route exact path='/women-3-piece-pret-stitched-suit-online-in-usa' component={Link54} />
          <Route exact path='/shop-asian-3-piece-stitched-suits-wedding-outfits-usa' component={Link55} />
          <Route exact path='/malook-couture-womens-luxury-dresses' component={Link56} />
          <Route exact path='/luxury-pret-online-women-dresses-malook' component={Link57} />
          <Route exact path='/women-lawn-pret-collection' component={Link58} />
          <Route exact path='/womens-pakistani-luxury-pret-online-in-uk-usa' component={Link59} />
          <Route exact path='/shop-luxury-pret-wear-collection' component={Link60} />
          <Route exact path='/womens-clothing-online-in-usa-buy-latest-design' component={Link61} />
          <Route exact path='/womens-luxury-pret-formal-wear' component={Link62} />
          <Route exact path='/luxury-pret-buy-pakistani-dresses-in-usa-uk' component={Link63} />
          <Route exact path='/women-pret-dress-in-usa-online' component={Link64} />
          <Route exact path='/pakistani-women-pret-dress-in-usa' component={Link65} />
          <Route exact path='/casual-women-pret-dress-in-usa' component={Link66} />
          <Route exact path='/pakistani-luxury-pret-collection-women-dresses' component={Link67} />
          <Route exact path='/luxury-pret-women-pret-wear-collection' component={Link68} />
          <Route exact path='/new-ready-to-wear-dresses-pret-collection-2025' component={Link69} />
          <Route exact path='/unstitched-pret-womens-clothing-malook-store' component={Link70} />
          <Route exact path='/stylish-pret-collection-ready-to-wear-womens' component={Link71} />
          <Route exact path='/pakistani-womens-pret-wear-online' component={Link72} />
          <Route exact path='/pakistani-women-pret-new-arrivals' component={Link73} />
          <Route exact path='/ready-to-wear-pakistani-dresses-for-women' component={Link74} />
          <Route exact path='/luxury-pret-online-and-luxury-ready-to-wear' component={Link75} />
          <Route exact path='/pret-unstitched-dresses-on-sale' component={Link76} />
          <Route exact path='/get-the-latest-womens-clothes-dresses' component={Link77} />
          <Route exact path='/ready-to-wear-womens-stitched-pret-wear' component={Link78} />
          <Route exact path='/buy-summer-ready-to-wear-pret-eid-dresses-usa' component={Link79} />
          <Route exact path='/ready-made-dresses-for-women-summer-2025' component={Link80} />
          <Route exact path='/pakistani-pret-wear-online' component={Link81} />
          <Route exact path='/best-pakistani-western-clothing-brand' component={Link82} />
          <Route exact path='/buy-online-ready-made-dresses-in-usa-uk' component={Link83} />
          <Route exact path='/ready-to-wear-women-collection-sale-up-to-70-off' component={Link84} />
          <Route exact path='/buy-ladies-luxury-pret-wear-collection' component={Link85} />
          <Route exact path='/best-women-clothing-brands-in-pakistan' component={Link86} />
          <Route exact path='/women-clothing-brand-online-in-pakistan' component={Link87} />
          <Route exact path='/latest-dress-designs-womens-clothing-usa-uk' component={Link88} />
          <Route exact path='/top-clothing-brand-in-pakistan-premium-women-apparel' component={Link89} />
          <Route exact path='/luxury-pret-collection-for-women-online' component={Link90} />
          <Route exact path='/buy-ladies-luxury-pret-wear-collection' component={Link91} />
          <Route exact path='/ready-to-wear-unstitched-womens-clothing-store' component={Link92} />
          <Route exact path='/shop-pret-dresses-for-women-online-in-usa' component={Link93} />
          <Route exact path='/shop-the-latest-womens-pret-collection-online' component={Link94} />
          <Route exact path='/luxury-clothing-designer-dresses-for-women' component={Link95} />
          <Route exact path='/women-dresses-in-uae-explore-latest-pakistani-dresses' component={Link96} />
          <Route exact path='/impression-wears-online-clothing-store-for-women' component={Link97} />
          <Route exact path='/valentino-womens-clothing-ready-to-wear-clothes' component={Link98} />
          <Route exact path='/ready-to-wear-online-in-pakistan' component={Link99} /> */}













          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/' component={} /> */}
          {/* <Route exact path='/track' component={tracking} /> */}
          
          



          <Route path='*' component={Error} />

        </Switch>

        <Footer />

      </Router>
    </div>
  );
}

export default App;
